import {theme as defaultTheme} from "@chakra-ui/core";

import {Tenant, Theme} from "./types";

import dates from "~/utils/date";

export function getTheme(color: Tenant["color"]): Theme {
  return {
    ...defaultTheme,
    colors: {
      ...defaultTheme.colors,
      primary: defaultTheme.colors[color],
    },
  };
}

export function getRevalidationTime(tier: Tenant["tier"]): number {
  switch (tier) {
    case "free": {
      // Time until next day
      return dates.secondsUntilNextDay;
    }

    case "preferential": {
      // Seconds until next hour
      return dates.secondsUntilNextHour;
    }

    case "trial":
    case "commercial": {
      // 10 seconds
      return 10;
    }

    default: {
      // 12 hours
      return dates.twelveHoursInSeconds;
    }
  }
}
